import { Flex } from 'shared/components/Flex'
import CompanyImage from 'shared/assets/companyImage.png'
import { SocialLinks } from 'shared/components/SocialLinks'

import {
    SocialLinksContainer,
    StyledCompanyImage,
    StyledNeutralText,
    StyledSecondaryLinkText,
    StyledSecondaryText,
    StyledSubHeader,
} from './styles'

export const InvoiceSubHeader = () => (
    <StyledSubHeader>
        <Flex gap={10}>
            <StyledCompanyImage src={CompanyImage} />
            <Flex flexDirection='column' justifyContent='space-between'>
                <div>
                    <StyledSecondaryText>
                        ФОТО, ВИДЕОСТУДИЯ:{' '}
                    </StyledSecondaryText>
                    <StyledNeutralText>Студия Background</StyledNeutralText>
                </div>
                <div>
                    <StyledSecondaryText>Адрес: </StyledSecondaryText>
                    <StyledNeutralText>
                        Россия, Москва, ул. Генерала Дорохова, 28А
                    </StyledNeutralText>
                </div>
                <div>
                    <StyledSecondaryText>Контакты: </StyledSecondaryText>
                    <StyledSecondaryLinkText>
                        +7 (985) 199-75-74 info@backg.ru
                    </StyledSecondaryLinkText>
                </div>
            </Flex>
        </Flex>
        <SocialLinksContainer>
            <SocialLinks />
        </SocialLinksContainer>
    </StyledSubHeader>
)
